import React, { useEffect, useState } from 'react';
import FileList from '../FileList/FileList';
import PaymentForm from '../PaymentForm/PaymentForm';
import CreditShipmentSelector from '../CreditShipmentSelector/CreditShipmentSelector';
import EmailSelector from '../EmailSelector/EmailSelector';
import CreditSelector from '../CreditSelector/CreditSelector';
import {
  fetchInvoiceByNumber,
  fetchClientByCode,
  payInvoice,
  reissueInvoice,
  createInvoice,
  generateInvoicePDF,
  setCreditStatus,
} from '../../services/api';
import MessageBox from '../MessageBox/MessageBox';
import './invoiceCommands.css';

export default function InvoiceCommands({ invoice_number, onClose }) {
  const [showFileList, setShowFileList] = useState(false);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [showCreditPaymentForm, setShowCreditPaymentForm] = useState(false);
  const [showCreditShipmentSelector, setShowCreditShipmentSelector] = useState(false);
  const [selectedShipments, setSelectedShipments] = useState([]);
  const [creditBillingDate, setCreditBillingDate] = useState(null);
  const [showMailSelector, setShowMailSelector] = useState(false);
  const [showCreditSelector, setShowCreditSelector] = useState(false);

  const [clientData, setClientData] = useState({
    client_code: '',
    payment_type: '',
  });

  const [invoiceData, setInvoiceData] = useState({
    invoice_number: '',
    legacy_invoice_number: '',
    document_type: '',
    client: '',
    billing_date: '',
    due_date: '',
    status: '',
    total: 0,
    vat: 0,
    total_including_tax: 0,
    diesel_tax: 0,
    billing_period: '',
    billing_month: '',
    related_shipments: '',
    payment_number: '',
    payment_date: '',
    payment_method: '',
  });

  const [showMessageBox, setShowMessageBox] = useState(false);
  const [messageBoxConfig, setMessageBoxConfig] = useState({
    message: '',
    type: 'ok',
    loading_button: false,
    input: false,
    onConfirm: null,
    onCancel: null,
  });

  useEffect(() => {
    const fetchData = async invoice_number => {
      if (invoice_number) {
        try {
          const fetchedData = await fetchInvoiceByNumber(invoice_number);
          const updatedFormData = {};
          Object.keys(invoiceData).forEach(key => {
            updatedFormData[key] =
              fetchedData[key] !== undefined && fetchedData[key] !== null
                ? fetchedData[key]
                : invoiceData[key];
          });
          setInvoiceData(updatedFormData);
        } catch (error) {
          console.error('Erreur lors de la récupération de la facture:', error);
        }
      }
    };

    fetchData(invoice_number);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchClient = async client_code => {
      if (client_code) {
        try {
          const fetchedData = await fetchClientByCode(client_code);
          const updatedFormData = {};
          Object.keys(clientData).forEach(key => {
            updatedFormData[key] =
              fetchedData[key] !== undefined && fetchedData[key] !== null
                ? fetchedData[key]
                : clientData[key];
          });
          setClientData(updatedFormData);
        } catch (error) {
          console.error('Erreur lors de la récupération du client:', error);
        }
      }
    };

    fetchClient(invoiceData.client);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceData.client]);

  const handleInvoiceDisplay = () => {
    setShowFileList(true);
  };

  const handleCloseFileList = () => {
    setShowFileList(false);
  };

  const handleShowPaymentForm = () => {
    setShowPaymentForm(true);
  };

  const handleConfirmPaymentForm = async (
    invoice_number,
    payment_number,
    payment_date,
    payment_method,
    dataHasChanged
  ) => {
    const PayInvoice = async (invoice_number, payment_number, payment_date, payment_method) => {
      try {
        const response = await payInvoice(
          invoice_number,
          payment_number,
          payment_date,
          payment_method
        );
        return response;
      } catch (error) {
        setMessageBoxConfig({
          message: `Une erreur est survenue lors du règlement de la facture: ${error}`,
          type: 'ok',
          loading_button: false,
          input: false,
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
      }
    };

    if (dataHasChanged) {
      const response = await PayInvoice(
        invoice_number,
        payment_number,
        payment_date,
        payment_method
      );

      if (response) {
        setMessageBoxConfig({
          message: `La facture a bien été réglée.`,
          type: 'ok',
          loading_button: false,
          input: false,
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
        setInvoiceData({
          ...invoiceData,
          payment_number: payment_number,
          payment_date: payment_date,
          payment_method: payment_method,
        });
        setShowPaymentForm(false);
        onClose();
      }
    } else {
      setShowPaymentForm(false);
    }
  };

  const handleClosePaymentForm = () => {
    setShowPaymentForm(false);
  };

  const handleReissueInvoiceClick = () => {
    setMessageBoxConfig({
      message: `Etes vous certain de vouloir rééditer le PDF ?`,
      type: 'yesno',
      loading_button: true,
      input: false,
      onConfirm: () => handleReissueInvoice(),
      onCancel: () => setShowMessageBox(false),
      onClose: () => setShowMessageBox(false),
    });
    setShowMessageBox(true);
  };

  const handleReissueInvoice = async () => {
    const ReissueInvoice = async invoice_number => {
      try {
        const response = await reissueInvoice(invoice_number);
        return response;
      } catch (error) {
        setMessageBoxConfig({
          message: `Une erreur est survenue lors de la réédition du PDF: ${error}`,
          type: 'ok',
          loading_button: false,
          input: false,
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
      }
    };

    const response = await ReissueInvoice(invoice_number);

    if (response) {
      setMessageBoxConfig({
        message: `Le PDF a bien été réédité.`,
        type: 'ok',
        loading_button: false,
        input: false,
        onConfirm: () => setShowMessageBox(false),
        onClose: () => setShowMessageBox(false),
      });
      setShowMessageBox(true);
    }
  };

  const handleCreateCredit = () => {
    setShowCreditShipmentSelector(true);
  };

  const handleConfirmCreditShipmentSelector = async (
    selected_shipments,
    showPreview = true,
    billingDate = null
  ) => {
    const fetchCreditPDF = async (selected_shipments, billingDate) => {
      try {
        const response = await generateInvoicePDF(
          clientData.client_code,
          selected_shipments,
          'credit',
          [],
          showPreview,
          billingDate
        );
        return response;
      } catch (error) {
        setMessageBoxConfig({
          message: `Une erreur est survenue lors de la génération du pdf: ${error}`,
          type: 'ok',
          loading_button: false,
          input: false,
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
      }
    };

    setSelectedShipments(selected_shipments);
    setCreditBillingDate(billingDate);
    const response = await fetchCreditPDF(selected_shipments, billingDate);

    if (response) {
      setShowCreditShipmentSelector(false);
      setShowMailSelector(true);
    }
  };

  const handleCancelCreditShipmentSelector = () => {
    setShowCreditShipmentSelector(false);
  };

  const handleCloseEmailSelector = () => {
    setShowMailSelector(false);
  };

  const handleCancelEmailSelector = () => {
    setShowMailSelector(false);
  };

  const handleConfirmEmailSelector = async email_list => {
    const CreateInvoice = async (selectedShipments, email_list, billingDate) => {
      try {
        const response = await createInvoice(
          clientData.client_code,
          selectedShipments,
          'credit',
          email_list,
          '',
          '',
          invoice_number,
          [],
          billingDate
        );
        return response;
      } catch (error) {
        setMessageBoxConfig({
          message: `Une erreur est survenue lors de la création de l'avoir': ${error}`,
          type: 'ok',
          loading_button: false,
          input: false,
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
      }
    };

    const response = await CreateInvoice(selectedShipments, email_list, creditBillingDate);

    if (response) {
      const { email_sent } = response;

      if (email_sent) {
        onClose();
      } else {
        setMessageBoxConfig({
          message: `L'envoi de l'email a rencontré une erreur, l'avoir n'a pas pu être créé. Merci de contacter un administrateur.`,
          type: 'ok',
          loading_button: false,
          input: false,
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
      }
    }
    setShowMailSelector(false);
  };

  const handleShowCreditSelector = () => {
    setShowCreditSelector(true);
  };

  const handleCloseCreditSelector = () => {
    setShowCreditSelector(false);
  };

  const handleConfirmCreditSelector = selected_credits => {
    setMessageBoxConfig({
      message: `Etes vous certain de vouloir appliquer le.s avoir.s sélectionnés sur la facture ${invoice_number} ?`,
      type: 'yesno',
      loading_button: true,
      input: false,
      onConfirm: () => handleApplyCredits(selected_credits),
      onCancel: () => setShowMessageBox(false),
      onClose: () => setShowMessageBox(false),
    });
    setShowMessageBox(true);
  };

  const handleApplyCredits = async selected_credits => {
    const ReissueInvoice = async (invoice_number, selected_credits) => {
      try {
        const response = await reissueInvoice(invoice_number, selected_credits);
        return response;
      } catch (error) {
        setMessageBoxConfig({
          message: `Une erreur est survenue lors de l'ajout de l'avoir sur la facture: ${error}`,
          type: 'ok',
          loading_button: false,
          input: false,
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
      }
    };

    const response = await ReissueInvoice(invoice_number, selected_credits);

    if (response) {
      setMessageBoxConfig({
        message: `Le PDF a bien été réédité avec le.s avoir.s.`,
        type: 'ok',
        loading_button: false,
        input: false,
        onConfirm: () => {
          setShowMessageBox(false);
          setShowCreditSelector(false);
          onClose();
        },
        onClose: () => {
          setShowMessageBox(false);
          setShowCreditSelector(false);
          onClose();
        },
      });
      setShowMessageBox(true);
    }
  };

  const handleSetCreditStatus = async () => {
    if (invoiceData.status === 'NON UTILISÉ') {
      setShowCreditPaymentForm(true);
    } else {
      const SetCreditStatusUnused = async () => {
        try {
          const response = await setCreditStatus(invoice_number, 'NON UTILISÉ');
          return response;
        } catch (error) {
          setMessageBoxConfig({
            message: `Une erreur est survenue lors du changement de statut: ${error}`,
            type: 'ok',
            loading_button: false,
            input: false,
            onConfirm: () => setShowMessageBox(false),
            onClose: () => setShowMessageBox(false),
          });
          setShowMessageBox(true);
        }
      };

      const response = await SetCreditStatusUnused();
      if (response) {
        setMessageBoxConfig({
          message: `L'avoir a bien été marqué comme non utilisé.`,
          type: 'ok',
          loading_button: false,
          input: false,
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
        setInvoiceData({
          ...invoiceData,
          status: 'NON UTILISÉ',
          payment_number: '',
          payment_date: '',
          payment_method: '',
        });
      }
    }
  };

  const handleConfirmCreditPaymentForm = async (
    _invoice_number,
    payment_number,
    payment_date,
    payment_method,
    dataHasChanged
  ) => {
    const SetCreditStatusUsed = async (payment_number, payment_date, payment_method) => {
      try {
        const response = await setCreditStatus(
          invoice_number,
          'UTILISÉ',
          payment_number,
          payment_date,
          payment_method
        );
        return response;
      } catch (error) {
        setMessageBoxConfig({
          message: `Une erreur est survenue lors du changement de statut: ${error}`,
          type: 'ok',
          loading_button: false,
          input: false,
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
      }
    };

    if (dataHasChanged) {
      const response = await SetCreditStatusUsed(payment_number, payment_date, payment_method);
      if (response) {
        setMessageBoxConfig({
          message: `L'avoir a bien été marqué comme utilisé.`,
          type: 'ok',
          loading_button: false,
          input: false,
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
        setInvoiceData({
          ...invoiceData,
          status: 'UTILISÉ',
          payment_number: payment_number,
          payment_date: payment_date,
          payment_method: payment_method,
        });
        setShowCreditPaymentForm(false);
        onClose();
      }
    } else {
      setShowCreditPaymentForm(false);
    }
  };

  const handleCloseCreditPaymentForm = () => {
    setShowCreditPaymentForm(false);
  };

  return (
    <div className="overlay">
      <div className="invoice-commands-content">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>
        <h3>
          {invoiceData.document_type === 'invoice' ? 'Facture' : 'Avoir'} n°{' '}
          {invoiceData.legacy_invoice_number || invoice_number}
        </h3>
        <div className="invoice-commands-button-line">
          <button type="button" onClick={handleInvoiceDisplay}>
            Aperçu
          </button>
          <button type="button" onClick={handleReissueInvoiceClick}>
            Rééditer PDF
          </button>
        </div>
        <div className="invoice-commands-button-line">
          {invoiceData.document_type === 'invoice' && invoiceData.payment_number === '' && (
            <button type="button" onClick={handleShowPaymentForm}>
              Régler facture
            </button>
          )}
          {invoiceData.document_type === 'invoice' && invoiceData.payment_number && (
            <button
              className="disabled"
              type="button"
              disabled={true}
              onClick={handleShowPaymentForm}
            >
              Facture réglée
            </button>
          )}
        </div>
        <div className="invoice-commands-button-line">
          {invoiceData.document_type === 'invoice' && (
            <button type="button" onClick={handleCreateCredit}>
              Éditer un avoir
            </button>
          )}
          {invoiceData.document_type === 'invoice' && (
            <button type="button" onClick={handleShowCreditSelector}>
              Appliquer un avoir
            </button>
          )}
          {invoiceData.document_type === 'credit' && (
            <button type="button" onClick={handleSetCreditStatus}>
              Marquer comme {invoiceData.status === 'NON UTILISÉ' ? 'utilisé' : 'non utilisé'}
            </button>
          )}
        </div>
      </div>

      {showFileList && (
        <FileList
          data_type={invoiceData.document_type}
          data_identifier={invoice_number}
          onClose={handleCloseFileList}
        />
      )}
      {showPaymentForm && (
        <PaymentForm
          invoice_number={invoiceData.legacy_invoice_number || invoice_number}
          document_type="invoice"
          payment_type={clientData.payment_type}
          payment_number={
            invoiceData.payment_number || invoiceData.legacy_invoice_number || invoice_number
          }
          payment_date={invoiceData.payment_date || new Date().toISOString().split('T')[0]}
          payment_method={invoiceData.payment_method}
          onConfirm={handleConfirmPaymentForm}
          onClose={handleClosePaymentForm}
        />
      )}
      {showCreditPaymentForm && (
        <PaymentForm
          invoice_number={invoiceData.legacy_invoice_number || invoice_number}
          document_type="credit"
          payment_type={clientData.payment_type}
          payment_number={invoiceData.payment_number}
          payment_date={invoiceData.payment_date || new Date().toISOString().split('T')[0]}
          payment_method={invoiceData.payment_method}
          onConfirm={handleConfirmCreditPaymentForm}
          onClose={handleCloseCreditPaymentForm}
        />
      )}
      {showCreditShipmentSelector && (
        <CreditShipmentSelector
          invoice_number={invoice_number}
          onConfirm={handleConfirmCreditShipmentSelector}
          onClose={handleCancelCreditShipmentSelector}
        />
      )}
      {showMailSelector && (
        <EmailSelector
          fetchFunction={fetchClientByCode}
          code={clientData.client_code}
          onClose={handleCloseEmailSelector}
          onConfirm={handleConfirmEmailSelector}
          onCancel={handleCancelEmailSelector}
        />
      )}
      {showCreditSelector && (
        <CreditSelector
          invoice_number={invoice_number}
          invoice_total={invoiceData.total}
          diesel_tax={invoiceData.diesel_tax}
          client_code={clientData.client_code}
          onClose={handleCloseCreditSelector}
          onConfirm={handleConfirmCreditSelector}
        />
      )}
      {showMessageBox && (
        <MessageBox
          message={messageBoxConfig.message}
          onClose={() => setShowMessageBox(false)}
          onConfirm={messageBoxConfig.onConfirm}
          onCancel={messageBoxConfig.onCancel}
          type={messageBoxConfig.type}
          loading_button={messageBoxConfig.loading_button}
          technicalDetails={messageBoxConfig.technicalDetails}
        />
      )}
    </div>
  );
}
